import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from './http.service';
import {APIResponse} from '../../../interfaces/system/system-common';
import {Dataset, DatasetCreator, DatasetType, DatasetPreview} from '../../../interfaces/common/dataset';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';

@Injectable()
export class DatasetApi {
    private readonly prefix = 'data/dataset';

    constructor(private api: HttpService) {}

    findOne(id: string): Observable<APIResponse<Dataset>> {
        return this.api.get(`${this.prefix}/${id}`);
    }

    create(data: DatasetCreator): Observable<APIResponse<Dataset>> {
        return this.api.post(`${this.prefix}/`, data);
    }

    update(id: string, data: Dataset): Observable<APIResponse<Dataset>> {
        return this.api.put(`${this.prefix}/${id}`, data);
    }

    delete(datasetId: string): Observable<APIResponse<boolean>> {
        return this.api.delete(`${this.prefix}/${datasetId}`, {});
    }

    reversePendingDelete(datasetId: string): Observable<APIResponse<boolean>> {
        return this.api.put(`${this.prefix}/reverse-pending-delete/${datasetId}`, {});
    }

    listLatestDataSet(pageSize: number, datasetType: string): Observable<Dataset[]> {
        return this.api.get(
            `${this.prefix}/list?pageNumber=1&pageSize=${pageSize}&filterBydatasetType_EQUAL=${datasetType}&sortBy=version&orderBy=desc`,
        );
    }

    listFiles(): Observable<DataSource> {
        return this.api.getServerDataSource(`${this.prefix}/list`);
    }

    listFilesByType(dataType: DatasetType): Observable<DataSource> {
        return this.api.getServerDataSource(`${this.prefix}/list?filterBydatasetType_EQUAL=${dataType}`);
    }

    listFilesByTypeAndStatus(dataType: DatasetType, status: string): Observable<DataSource> {
        return this.api.getServerDataSource(
            `${this.prefix}/list?filterBydatasetType_EQUAL=${dataType}&filterBystatus_EQUAL=${status}`,
        );
    }

    getDatasetPreviewByIds(datasetIds: number[]): Observable<APIResponse<DatasetPreview[]>> {
        return this.api.post(`${this.prefix}/preview/results`, {datasetIds: datasetIds});
    }
}
